import PosCartActions from '../../../actions/PosCartActions';

import UserStore from '../../../stores/UserStore';

import Price from '../../form/Price.react';

class CartDiscount extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid     : uuid(),
            show     : false
        };

        this.removeDiscount = this.removeDiscount.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    removeDiscount(data) {
        var guest           = this.props.guest;

        if (data.hasOwnProperty('items')) {
            const discountIds = data.items.map(x => x.AppliedDiscountId);
            PosCartActions.removeMultipleAppliedDiscounts(guest, discountIds, true);
        } else {
            PosCartActions.removeAppliedDiscount(guest, data.AppliedDiscountId, true);

            $('#main_'+this.state.uuid).css({
                'height' : $('#main_'+this.state.uuid).height() - 60
            });
        }
    }

    toggle(e) {
        if (e.target.className === 'cart-discounts__child--remove' ||
            e.target.className === 'fa fa-times' ||
            e.target.className === 'cart-discounts__remove-all')
            return;

        this.setState({
            show : !this.state.show
        });
    }

    render() {
        var guest                = this.props.guest;
        var item                 = this.props.item;
        var i                    = this.props.i;

        var title = item.DiscountReason.split(') ')[1] || item.DiscountReason;

        return (
            <div
                className={'cart-discounts__item '+(i % 2 ? 'cart-discounts__item--grey' : '')}
                id={this.state.uuid}
                onClick={this.toggle}>

                <div className='cart-discounts__title'>
                    {title}
                </div>

                <Price
                    className='cart-discounts__item--amount'
                    price={item.DiscountAmt}
                    dollar />

                { this.state.show &&
                    !item.items[0].IsLoyalty &&
                    <div
                        className='cart-discounts__remove-all'
                        onClick={this.removeDiscount.bind(this, item)}>

                        Remove all
                    </div>
                }

                { this.state.show && item.items.map((discount) => {
                    return (
                        <div
                            className='cart-discounts__child'
                            key={discount.InvId+'-'+discount.DiscountId}>

                            { !discount.IsLoyalty &&

                            <div
                                className='cart-discounts__child--remove'
                                title='Remove Discount'
                                onClick={this.removeDiscount.bind(this, discount)}>

                                <i className='fa fa-times' aria-hidden='true' />
                            </div>}

                            <div className='cart-discounts__child--title'>
                                {discount.ProductName}
                            </div>

                            <div className='cart-discounts__child--title'>
                                {discount.SerialNumber}
                            </div>

                            <div className='cart-discounts__child--title'>
                                <Price
                                    className='cart-discounts__child--amount'
                                    price={discount.DiscountAmt}
                                    dollar />
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default CartDiscount;


/*
                <Price
                    className='cart-discounts__child--amount'
                    price={item.DiscountAmt}
                    dollar />






                            <Price
                                className='cart-discounts__child--amount'
                                price={discount.DiscountAmt}
                                dollar />

*/


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/cart/CartDiscounts.react.jsx